import styled, { keyframes } from 'styled-components';

const waveAnimation = (y: number) => keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(${y}px);
  }
`;

const Wave = styled.path<{ animate: boolean }>`
  animation-iteration-count: infinite;
  animation-duration: 6s;
  animation-timing-function: ease-in;
`;

export const Wave1 = styled(Wave)`
  animation-name: ${({ animate }) => (animate ? waveAnimation(-8) : 'none')};
`;

export const Wave2 = styled(Wave)`
  animation-name: ${({ animate }) => (animate ? waveAnimation(4) : 'none')};
`;
